import React from "react"
import { fireStore, storageRef } from "../firebase/firebase"
import { useStore } from "../context/context"
import { useAuth } from "../firebase/useAuth"
import { Tooltip } from "@material-ui/core"
import { Delete } from "@material-ui/icons"

export default function ClearAllPostBtn({ isScreenSmall }) {
	const [currentUser] = useAuth()
	const { dispatch } = useStore()
	
	const handleClick = () => {
    const userIsSure = confirm("Êtes vous sûre de vouloir effacer tout vos posts ?")
    if(!userIsSure) return
		storageRef.child(currentUser?.displayName).listAll().then(res => {
				res.items.forEach(item => item.delete())
    })
		fireStore.collection("users").doc(currentUser?.uid).update({
      posts: []
    }).then(() => dispatch({ type: "SET_NOTIFICATION", payload: "Vos posts ont bien été éffacés" }))
	}

	if(!isScreenSmall) return (
		<Tooltip title="Effacer tout les posts" placement="left" arrow>
			<button className="clearAllPostBtn" onClick={handleClick}>
				<Delete className="deleteIcon" />
			</button>
		</Tooltip>
  )
  
  return (
    <button className="clearAllPostBtn" onClick={handleClick}>
      <Delete className="deleteIcon" /> Effacer les posts
    </button>
  )
}
